// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {TextField} from '@wandb/weave/components/Form/TextField';
import {debounce} from 'lodash';
import * as React from 'react';
import {useContext, useMemo, useState} from 'react';

import {SingleRegistrySearchContext} from './RegistriesSearchContextProvider';

const SEARCH_BAR_DEBOUNCE_MS = 500;

export const SingleRegistrySearchBar = () => {
  const {searchFilter, setSearchFilter} = useContext(
    SingleRegistrySearchContext
  );
  const [searchBarText, setSearchBarText] = useState(searchFilter ?? '');

  const setSearchFilterDebounced = useMemo(
    () =>
      debounce(
        (value: string) => setSearchFilter(value),
        SEARCH_BAR_DEBOUNCE_MS
      ),
    [setSearchFilter]
  );

  const onTextChange = (value: string) => {
    setSearchBarText(value);

    // If we're editing text in the search bar, only auto-fetch results if:
    // - there's an existing search filter (i.e. editing a previous search)
    // - the new text is empty (i.e. clearing the search)
    // - or otherwise, if there are enough characters in a new search.
    // The user can always press enter if they want to force a search on a single character.
    const normalizedSearchText = value.trim();
    if (
      searchFilter ||
      !normalizedSearchText ||
      normalizedSearchText.length > 1
    ) {
      setSearchFilterDebounced(normalizedSearchText);
    }
  };

  const onKeyPress = (e: string) => {
    if (e === 'Enter') {
      setSearchFilter(searchBarText.trim() || undefined);
    }
  };

  // Cleanup debounced function on unmount
  React.useEffect(() => {
    return () => {
      setSearchFilterDebounced.cancel();
    };
  }, [setSearchFilterDebounced]);

  return (
    <div className="font-base mb-24 mt-16 flex w-full items-center">
      <TextField
        size="large"
        placeholder="Search collection names, tags and version tags"
        value={searchBarText}
        autoFocus={true}
        onChange={(value: string) => onTextChange(value)}
        icon="search"
        onKeyDown={e => onKeyPress(e)}
        extraActions={
          searchBarText ? (
            <Button
              variant="ghost"
              icon="close"
              size="small"
              className="mr-4"
              onClick={() => {
                setSearchBarText('');
                setSearchFilter(undefined);
              }}
            />
          ) : undefined
        }
      />
    </div>
  );
};
